const Hero = () => {
  return (
    <div
    className="relative z-0 flex-wrap min-h-screen gap-2 md:-mt-10 flex-center-center"
    style={{
      background: "url('/images/hero-bg-pattern.png')",
      backgroundRepeat: "no-repeat",
      backgroundSize: "contain",
    }}
  >
    <div className="absolute top-0 right-0 rounded-full bg-[#04a7ff]/30 dark:bg-[#04a7ff]/50 w-72 h-72 -z-10 blur-[120px]"></div>
    <div className="flex-1 basis-[20rem]">
      <h1 className="text-3xl font-semibold capitalize md:text-4xl">
        Discover Your Ideal <br /> Food & Living Spaces
      </h1>
      <div className="pl-3 mt-5 border-l-4 border-primary">
        <p>
          Find the perfect place to live, eat, and enjoy. Explore flats, tiffin services, and food centers tailored to your needs.
        </p>
      </div>
      <button className="mt-6 btn btn-primary">Get Started</button>
      <div className="mt-6 text-center flex-align-center gap-x-6">
  <div>
    <h1 className="text-2xl font-bold">
      10k <span className="text-sm text-primary">+</span>
    </h1>
    <p>Happy Tenants</p>
  </div>
  <div>
    <h1 className="text-2xl font-bold">
      5k <span className="text-sm text-primary">+</span>
    </h1>
    <p>Daily Meals</p>
  </div>
  <div>
    <h1 className="text-2xl font-bold">
      500 <span className="text-sm text-primary">+</span>
    </h1>
    <p>Verified Owners</p>
  </div>
</div>

    </div>
    <div className="flex-1 basis-[20rem]">
      <img src="/images/hero-4.png" alt="" className="w-full" />
    </div>
  </div>
  
  );
};

export default Hero;
